// Draws the Schedule of Work PDF from its model (docs/SCHEDULE-OF-WORK.md).
// jsPDF is loaded only here, when a document is made — not with the app.
import type { ScheduleArea, ScheduleOptions } from './model';
import { drawAreas } from './pdf-areas';
import { drawCover, drawSummary, type CoverDetails } from './pdf-cover';
import { embedRoboto } from './pdf-fonts';
import { PdfPage } from './pdf-kit';
import type { LoadedPhoto } from './photos';

export interface ScheduleDocument {
  cover: CoverDetails;
  areas: ScheduleArea[];
  options: ScheduleOptions;
  photos: ReadonlyMap<string, LoadedPhoto>;
}

export async function drawSchedule({ cover, areas, options, photos }: ScheduleDocument): Promise<Blob> {
  const { jsPDF } = await import('jspdf');
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4', compress: true });
  await embedRoboto(doc);
  doc.setProperties({ title: `${cover.jobNumber} Schedule of Work`, subject: cover.jobName ?? '', author: cover.preparedBy ?? 'Higgins Coatings', creator: 'Measure2Quote' });
  const page = new PdfPage(doc, [cover.jobNumber, cover.client].filter(Boolean).join(' · '));
  const coverPhoto = options.includePhotos && options.coverPhotoId ? (photos.get(options.coverPhotoId) ?? null) : null;
  drawCover(page, cover, areas, coverPhoto);
  drawSummary(page, areas, options);
  drawAreas(page, areas, options, photos);
  page.drawFooters(cover.date);
  return doc.output('blob');
}
